"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adyen_checkout_mounter_1 = require("./adyen_checkout_mounter");
function mountAdyenSecuredFields(args) {
    adyen_checkout_mounter_1.mountComponent({
        domSelector: args.domSelector,
        type: 'securedfields',
        locale: args.locale,
        props: {
            onFieldValid: args.onFieldValid,
            onBrand: args.onBrand,
            onFocus: args.onFocus,
            onError: args.onError,
            onConfigSuccess: args.onConfigSuccess,
            styles: {
                base: {
                    background: 'transparent',
                    color: '#212121',
                    fontSize: '16px',
                    fontSmoothing: 'auto',
                    fontFamily: 'Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace',
                    fontWeight: '400',
                    lineHeight: '1.4',
                    padding: '6px 8px',
                },
            },
        },
    });
}
exports.mountAdyenSecuredFields = mountAdyenSecuredFields;
//# sourceMappingURL=adyen_secured_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/adyen_secured_fields.js
// module id = V27/
// module chunks = 20 21 22